<template>
  <div class="row gy-5 g-xl-8">
    <div class="col-xxl-4">
      <TotalizadoresCadastros
        id="dashboard_resumo_operacional"
        :widget-classes="'card-xl-stretch mb-xl-8'"
        :widget-color="'danger'"
        :chart-height="200"
      >
      </TotalizadoresCadastros>
    </div>
    <div class="col-xxl-4">
      <AcessoRapido
        id="dashboard_acesso_rapido"
        widget-classes="card-xxl-stretch mb-5 mb-xl-10"
        :widget-color="'secondary'"
      ></AcessoRapido>
    </div>
    <div class="col-xxl-4">
      <GraficoFaturamento
        id="dashboard_grafico_faturamento_barras"
        :widget-classes="'card-xxl-stretch-50 mb-3 mb-xl-8'"
        :chart-color="'primary'"
        :chart-height="170"
      ></GraficoFaturamento>
      <GraficoSituacaoNFe
        id="dashboard_grafico_faturamento_situacao"
        :widget-classes="'card-xxl-stretch-50 mb-3 mb-xl-10'"
        :chart-color="'primary'"
        :chart-height="150"
      ></GraficoSituacaoNFe>
    </div>
  </div>
  <div class="row gy-5 gx-xl-8 mb-5 mb-xl-3">
    <div class="col-xxl-4">
      <ClientesMaisCompraram
        id="dashboard_clientes_mais_compraram"
        widget-classes="card-xxl-stretch mb-5 mb-xl-8"
      ></ClientesMaisCompraram>
    </div>
    <div class="col-xxl-8">
      <UltimosClientesCadastrados
        widget-classes="card-xxl-stretch mb-5 mb-xl-8"
      ></UltimosClientesCadastrados>
    </div>
  </div>
  <div class="row gy-5 g-xl-8">
    <div class="col-xxl-8">
      <UltimosProdutosCadastrados
        widget-classes="card-xxl-stretch mb-5 mb-xl-8"
      ></UltimosProdutosCadastrados>
    </div>
    <div class="col-xxl-4">
      <ProdutosMaisVendidos
        widget-classes="card-xxl-stretch mb-xl-3"
      ></ProdutosMaisVendidos>
    </div>
  </div>
</template>

<script>
import TotalizadoresCadastros from "./widgets/dashboard/TotalizadoresCadastros.vue";
import GraficoFaturamento from "./widgets/dashboard/GraficoFaturamento.vue";
import AcessoRapido from "./widgets/dashboard/AcessoRapido.vue";
import GraficoSituacaoNFe from "./widgets/dashboard/GraficoSituacaoNFe.vue";
import UltimosClientesCadastrados from "./widgets/dashboard/UltimosClientesCadastrados.vue";
import ClientesMaisCompraram from "./widgets/dashboard/ClientesMaisCompraram.vue";
import UltimosProdutosCadastrados from "./widgets/dashboard/UltimosProdutosCadastrados.vue";
import ProdutosMaisVendidos from "./widgets/dashboard/ProdutosMaisVendidos.vue";
import { mapState } from "vuex";

export default {
  name: "dashboard",
  components: {
    TotalizadoresCadastros,
    GraficoFaturamento,
    AcessoRapido,
    GraficoSituacaoNFe,
    UltimosClientesCadastrados,
    ClientesMaisCompraram,
    UltimosProdutosCadastrados,
    ProdutosMaisVendidos,
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    async startTour() {
      this.tour = this.$shepherd({
        useModalOverlay: true,
        defaultStepOptions: {
          classes: "shadow-md bg-purple-dark",
          cancelIcon: {
            enabled: true,
            iconClass: "fas fa-times",
          },
          scrollTo: true,
        },
      });

      const mensagem = `<h3 style="text-align:center">Bem-vindo ao Gateway</h3>
                        <br/>
                        <p style="text-align:center">O Gateway é a sua solução completa para gestão empresarial. Vamos começar um tour para ajudá-lo a explorar tudo o que ele oferece.</p>
                        <p style="text-align:center">Estamos comprometidos em ajudar a sua empresa a prosperar. Seja qual for o desafio que você enfrenta, o Gateway está aqui para tornar sua jornada empresarial mais fácil.</p>
                        <p style="text-align:center"><img alt="" src="media/svg/illustrations/easy/8.svg"/></p>
                        <p>Clique no botão <strong>"Começar tour"</strong> abaixo para iniciar o tour.</p>`;

      this.tour.addStep({
        text: mensagem,
        buttons: [
          {
            text: '<i class="fas fa-arrow-alt-circle-left me-2"></i>Sair',
            action: this.tour.cancel,
            secondary: true,
          },
          {
            text: 'Começar tour<i class="fas fa-arrow-alt-circle-right ms-2"></i> ',
            action: this.tour.next,
            secondary: false,
          },
        ],
      });

      const windowWidth = window.innerWidth;

      if (windowWidth >= 768) {
        //Desktop

        this.tour.addStep({
          attachTo: {
            element: document.getElementById("kt_app_sidebar"),
            on: "right",
          },
          text: "Este é o menu do sistema, onde será listado os módulos que você terá acesso.",
          buttons: [
            {
              text: '<i class="fas fa-arrow-alt-circle-left me-2"></i>Voltar',
              action: this.tour.back,
              secondary: true,
            },
            {
              text: 'Próximo<i class="fas fa-arrow-alt-circle-right ms-2"></i> ',
              action: this.tour.next,
              secondary: false,
            },
          ],
        });

        this.tour.addStep({
          attachTo: {
            element: document.getElementById("kt_app_sidebar_toggle"),
            on: "right",
          },
          text: "Você pode ocultar o menu clicando sobre este ícone.",
          buttons: [
            {
              text: '<i class="fas fa-arrow-alt-circle-left me-2"></i>Voltar',
              action: this.tour.back,
              secondary: true,
            },
            {
              text: 'Próximo<i class="fas fa-arrow-alt-circle-right ms-2"></i> ',
              action: this.tour.next,
              secondary: false,
            },
          ],
        });

        this.tour.addStep({
          attachTo: {
            element: document.getElementById("kt_app_header"),
            on: "bottom",
          },
          text: "Este é o cabeçalho da página, onde contém um acesso rápido para o menu, notificações e acesso ao seu perfil.",
          buttons: [
            {
              text: '<i class="fas fa-arrow-alt-circle-left me-2"></i>Voltar',
              action: this.tour.back,
              secondary: true,
            },
            {
              text: 'Próximo<i class="fas fa-arrow-alt-circle-right ms-2"></i> ',
              action: this.tour.next,
              secondary: false,
            },
          ],
        });

        this.tour.addStep({
          attachTo: {
            element: document.getElementById("kt_header_user_menu_toggle"),
            on: "bottom",
          },
          text: "Aqui você tem acesso ao seu perfil, e também pode sair da aplicação.",
          buttons: [
            {
              text: '<i class="fas fa-arrow-alt-circle-left me-2"></i>Voltar',
              action: this.tour.back,
              secondary: true,
            },
            {
              text: 'Próximo<i class="fas fa-arrow-alt-circle-right ms-2"></i> ',
              action: this.tour.next,
              secondary: false,
            },
          ],
        });

        this.tour.addStep({
          attachTo: {
            element: document.getElementById("kt_header_change_theme"),
            on: "bottom",
          },
          text: "Altere o tema de claro para escuro clicando sobre este ícone",
          buttons: [
            {
              text: '<i class="fas fa-arrow-alt-circle-left me-2"></i>Voltar',
              action: this.tour.back,
              secondary: true,
            },
            {
              text: 'Próximo<i class="fas fa-arrow-alt-circle-right ms-2"></i> ',
              action: this.tour.next,
              secondary: false,
            },
          ],
        });

        this.tour.addStep({
          attachTo: {
            element: document.getElementById("kt_app_content_container"),
          },
          text: `<p>Esta é a sua página principal na aplicação. Aqui serão exibidos os resumos mais importantes sobre o seu negócio, como gráficos, atalhos, entre outros recursos.</p>`,
          buttons: [
            {
              text: '<i class="fas fa-arrow-alt-circle-left me-2"></i>Voltar',
              action: this.tour.back,
              secondary: true,
            },
            {
              text: 'Próximo<i class="fas fa-arrow-alt-circle-right ms-2"></i> ',
              action: this.tour.next,
              secondary: false,
            },
          ],
        });

        this.tour.addStep({
          attachTo: {
            element: document.getElementById("dashboard_resumo_operacional"),
            on: "right",
          },
          text: "Este é um resumo operacional, contabilizando a quantidade de produtos, clientes, faturamentos entre outros totalizadores.",
          buttons: [
            {
              text: '<i class="fas fa-arrow-alt-circle-left me-2"></i>Voltar',
              action: this.tour.back,
              secondary: true,
            },
            {
              text: 'Próximo<i class="fas fa-arrow-alt-circle-right ms-2"></i> ',
              action: this.tour.next,
              secondary: false,
            },
          ],
        });

        this.tour.addStep({
          attachTo: {
            element: document.getElementById("dashboard_acesso_rapido"),
            on: "right",
          },
          text: "Aqui temos um atalho para os módulos mais utilizados.",
          buttons: [
            {
              text: '<i class="fas fa-arrow-alt-circle-left me-2"></i>Voltar',
              action: this.tour.back,
              secondary: true,
            },
            {
              text: 'Próximo<i class="fas fa-arrow-alt-circle-right ms-2"></i> ',
              action: this.tour.next,
              secondary: false,
            },
          ],
        });
      } else {
        this.tour.addStep({
          attachTo: {
            element: document.getElementById("kt_app_sidebar_mobile_toggle"),
            on: "bottom",
          },
          text: "Acesse o menu com os modulos clicando sobre este botão",
          buttons: [
            {
              text: '<i class="fas fa-arrow-alt-circle-left me-2"></i>Voltar',
              action: this.tour.back,
              secondary: true,
            },
            {
              text: 'Próximo<i class="fas fa-arrow-alt-circle-right ms-2"></i> ',
              action: this.tour.next,
              secondary: false,
            },
          ],
        });
        this.tour.addStep({
          attachTo: {
            element: document.getElementById("kt_app_header_menu_toggle"),
            on: "bottom",
          },
          text: "Você também pode acessar o menu clicando aqui",
          buttons: [
            {
              text: '<i class="fas fa-arrow-alt-circle-left me-2"></i>Voltar',
              action: this.tour.back,
              secondary: true,
            },
            {
              text: 'Próximo<i class="fas fa-arrow-alt-circle-right ms-2"></i> ',
              action: this.tour.next,
              secondary: false,
            },
          ],
        });
        this.tour.addStep({
          attachTo: {
            element: document.getElementById("kt_header_change_theme"),
            on: "bottom",
          },
          text: "Altere o tema de claro para escuro clicando sobre este ícone",
          buttons: [
            {
              text: '<i class="fas fa-arrow-alt-circle-left me-2"></i>Voltar',
              action: this.tour.back,
              secondary: true,
            },
            {
              text: 'Próximo<i class="fas fa-arrow-alt-circle-right ms-2"></i> ',
              action: this.tour.next,
              secondary: false,
            },
          ],
        });
        this.tour.addStep({
          attachTo: {
            element: document.getElementById("kt_header_user_menu_toggle"),
            on: "bottom",
          },
          text: "Aqui você tem acesso ao seu perfil, e também pode sair da aplicação.",
          buttons: [
            {
              text: '<i class="fas fa-arrow-alt-circle-left me-2"></i>Voltar',
              action: this.tour.back,
              secondary: true,
            },
            {
              text: 'Próximo<i class="fas fa-arrow-alt-circle-right ms-2"></i> ',
              action: this.tour.next,
              secondary: false,
            },
          ],
        });

        this.tour.addStep({
          attachTo: {
            element: document.getElementById("dashboard_resumo_operacional"),
            on: "right",
          },
          text: "Este é um resumo operacional, contabilizando a quantidade de prdutos, clientes, faturamentos entre outros totalizadores.",
          buttons: [
            {
              text: '<i class="fas fa-arrow-alt-circle-left me-2"></i>Voltar',
              action: this.tour.back,
              secondary: true,
            },
            {
              text: 'Próximo<i class="fas fa-arrow-alt-circle-right ms-2"></i> ',
              action: this.tour.next,
              secondary: false,
            },
          ],
        });

        this.tour.addStep({
          attachTo: {
            element: document.getElementById("dashboard_acesso_rapido"),
            on: "right",
          },
          text: "Aqui temos um atalho para os módulos mais utilizados.",
          buttons: [
            {
              text: '<i class="fas fa-arrow-alt-circle-left me-2"></i>Voltar',
              action: this.tour.back,
              secondary: true,
            },
            {
              text: 'Próximo<i class="fas fa-arrow-alt-circle-right ms-2"></i> ',
              action: this.tour.next,
              secondary: false,
            },
          ],
        });
      }
      this.tour.addStep({
        attachTo: {},
        text: `<h3 style="text-align:center">Pronto!</h3>
                        <br/>
                        <p style="text-align:center">Agradecemos por concluir o nosso tour. Esperamos que agora você se sinta mais à vontade com a nossa aplicação. Se surgirem mais perguntas ou se você precisar de assistência adicional, nossa equipe de suporte técnico está sempre à disposição para ajudar. Não hesite em entrar em contato a qualquer momento. Estamos aqui para tornar a sua experiência conosco a melhor possível.</p>                        
                        <p style="text-align:center"><img alt="" src="media/svg/illustrations/Complete-task.svg" style="width:100%;height:100%"/></p>`,
        buttons: [
          {
            text: '<i class="fas fa-arrow-alt-circle-left me-2"></i>Voltar',
            action: this.tour.back,
            secondary: true,
          },
          {
            text: 'Finalizar Tour<i class="fas fa-check-circle ms-2"></i> ',
            action: this.tour.next,
            secondary: false,
          },
        ],
      });
      this.tour.on("complete", async () => {
        if ((await this.exibirTour()) === false) {
          let assistente = {
            modulo: "Dashboard",
            usuario: this.user.User.id,
          };

          try {
            var ret = await this.$store.dispatch(
              "assistenteModulos/postAssistenteModulos",
              assistente
            );
          } catch (error) {
            console.log(error);
          }
        }
      });
    },
    async exibirTour() {
      try {
        var ret = await this.$store.dispatch(
          "assistenteModulos/getAssistenteModulosOData",
          "?$select=modulo&$filter=modulo eq 'Dashboard' and usuario eq " +
            this.user.User.id
        );
        if (ret.value !== null && ret.value.length > 0) {
          return true;
        }
      } catch (error) {
        console.log(error);
        return true;
      }
      return false;
    },
  },
  async mounted() {
    const loggedIn = localStorage.getItem("user");
    if (!loggedIn) {
      //this.$router.push({ name: "sign-in" });
    } else {
      if (
        this.user.User &&
        this.user.User.assistente_boas_vindas &&
        this.user.User.assistente_boas_vindas === "1"
      ) {
        if ((await this.exibirTour()) === false) {
          this.startTour();
          this.tour.start();
        }
      }
    }
  },
  data() {
    return {};
  },
};
</script>
<style>
/* .shepherd-text {
  margin: 10px;
} */

.shepherd-footer {
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}

.shepherd-button i.fas.fa-arrow-alt-circle-right {
  color: hsla(0, 0%, 100%, 0.75);
}

.shepherd-button i.fas.fa-check-circle {
  color: hsla(0, 0%, 100%, 0.75);
}
</style>
